import { render, staticRenderFns } from "./article7.vue?vue&type=template&id=0fbdfbb1&scoped=true"
import script from "./article7.vue?vue&type=script&lang=js"
export * from "./article7.vue?vue&type=script&lang=js"
import style0 from "./article7.vue?vue&type=style&index=0&id=0fbdfbb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbdfbb1",
  null
  
)

export default component.exports